import {CURRENCY} from "../../../../settings/settings";

export default function PackageCard({className, isSelected, name, description, price, oldPrice, onClick, ...props}) {

    return (
        <div
            onClick={onClick}
            className={`shadow-md  lg:shadow-lg hover:scale-105 cursor-pointer flex pb-6 flex-col
             lg:gap-4 justify-center items-center gap-2 rounded-lg  ${isSelected && "border-[1px] border-tertiary-400"} ${className}`}>
            <div
                className={`text-tertiary-900 justify-center flex flex-col items-center py-2 ${isSelected ? "bg-tertiary-900   w-full text-white text-center rounded-lg" :
                    "bg-secondary-800  w-full text-white text-center rounded-lg"
                } `}>
                <p className={"font-semibold text-xl mb-2"}> {name}</p>
                <p>{description}</p>
            </div>
            <p className={"text-3xl font-bold "}>
                {
                    oldPrice && oldPrice > 0 && <span className={"text-red-500 mr-2 line-through"}>
                     {CURRENCY}{oldPrice}</span>
                }
                {CURRENCY}{price}
            </p>
        </div>

    )
}